// libs
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBox,
  faBoxesStacked,
  faUsers,
  faShoppingCart,
  faIndianRupeeSign,
  faChartLine,
  faTriangleExclamation,
  faTicket,
} from '@fortawesome/free-solid-svg-icons';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const iconMap = {
  box: faBox,
  boxes: faBoxesStacked,
  users: faUsers,
  cart: faShoppingCart,
  rupee: faIndianRupeeSign,
  chart: faChartLine,
  warning: faTriangleExclamation,
  ticket: faTicket,
};

function CardBlock({ title, value, prefix = '', icon = 'box', isLoading }) {
  const IconComponent = iconMap[icon] || iconMap.box;
  const displayValue = isLoading ? '...' : (value !== undefined && value !== null ? value : '0');

  return (
    <Card className="mb-4 mb-xl-0">
      <Card.Body>
        <Row>
          <Col>
            <h5 className="card-title text-uppercase text-muted mb-0">{title}</h5>
            <div className="h2 font-weight-bold mb-0">{prefix}{displayValue}</div>
          </Col>
          <Col xs="auto" md="auto">
            <div className="icon icon-shape">
              <FontAwesomeIcon icon={IconComponent} className="dashboard-card-icon" />
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default CardBlock;
